module.exports = __webpack_public_path__ + "img/Etecno.c6c61065.png";